import { ProjectSource } from 'generated/graphql';

export const PROJECT_SOURCE_LABELS = {
  [ProjectSource.AdminApp]: 'Admin app',
  [ProjectSource.RoleKickoff]: 'Company app',

};